interface StarIconFilledProps {
  className?: string;
  color?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

export const StarIconFilled = ({
  className = "",
  color = "currentColor",
  size = "md",
}: StarIconFilledProps) => {
  const sizeClasses = {
    sm: "w-4 h-4",  // ~16x16px
    md: "w-6 h-6",  // ~24x24px (approx for 27x26 viewBox)
    lg: "w-8 h-8",  // ~32x32px
    xl: "w-10 h-10", // ~40x40px
  };

  return (
    <div className="icon star-icon-filled">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27 26"
        fill="none"
        className={`${sizeClasses[size]} ${className}`}
        aria-hidden="true"
      >
        <path
          d="M5.38281 24.9297C5.14062 24.75 4.99219 24.5078 4.9375 24.2031C4.89062 23.8984 4.94141 23.5352 5.08984 23.1133L7.53906 15.8242L1.28125 11.3242C0.914062 11.0664 0.660156 10.8008 0.519531 10.5273C0.378906 10.2539 0.355469 9.97266 0.449219 9.68359C0.542969 9.40234 0.726562 9.19531 1 9.0625C1.27344 8.92188 1.63672 8.85156 2.08984 8.85156H9.76562L12.0977 1.57422C12.2383 1.14453 12.4141 0.820313 12.625 0.601562C12.8438 0.382812 13.1016 0.273438 13.3984 0.273438C13.7031 0.273438 13.9609 0.382812 14.1719 0.601562C14.3906 0.820313 14.5703 1.14453 14.7109 1.57422L17.043 8.85156H24.7188C25.1719 8.85156 25.5352 8.92188 25.8086 9.0625C26.082 9.19531 26.2656 9.40234 26.3594 9.68359C26.4531 9.97266 26.4297 10.2539 26.2891 10.5273C26.1484 10.8008 25.8945 11.0664 25.5273 11.3242L19.2695 15.8242L21.7188 23.1133C21.8672 23.5352 21.9141 23.8984 21.8594 24.2031C21.8125 24.5078 21.668 24.75 21.4258 24.9297C21.1836 25.1172 20.9102 25.1797 20.6055 25.1172C20.3008 25.0625 19.9688 24.9062 19.6094 24.6484L13.3984 20.0898L7.19922 24.6484C6.83984 24.9062 6.50781 25.0625 6.20312 25.1172C5.89844 25.1797 5.625 25.1172 5.38281 24.9297Z"
          fill={color}
        />
      </svg>
    </div>
  );
};


